// Gear → three tools (DEMI → TYTN → OLMPN), re-exported from ascension.ts.
export { GEAR_TIERS, TIER_ORDER, tierOf } from '../olmps/ascension';
export type DmtToolIdLike = string;
